import china from '@/config/china'
import english from '@/config/english'

export default {
  lang(state) {
    return state.language === 'cn' ? china : english
  }, 
  china(state) {
    return state.language === 'cn'
  }
}